<h2 mat-dialog-title>Document Upload</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <div class="flex-container">
        <div class="flex-item-1">
          <input class="file-upload" type="file" id="file" (change)="handleFileInput($event.target.files)">
        </div>
        @if (document != null) {
          <div class="flex-item-2">
            <button style="margin-left: 5px;" mat-raised-button (click)="download()">
              <mat-icon aria-hidden="false" aria-label="Download Example">download</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
  @if (fileToUpload != null) {
    <div class="row">
      <div class="col-12">
        {{fileToUpload.name}}
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="saveClicked">Cancel</button>
  <button id="template_upload_save" mat-button form="uploadTemplate" [disabled]="saveClicked" (click)="upload()">
    @if (saveClicked) {
      <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
    }
    @if (!saveClicked) {
      <span>Upload</span>
    }
  </button>
</mat-dialog-actions>
